/**
 * Goal Draft hooks — CCA-M3
 *
 * useGoalDraft   — mutation: POST /api/v1/goals/draft  (AC-CCA-12)
 * useGoalRefine  — mutation: POST /api/v1/goals/refine (AC-CCA-13)
 */

import { useMutation } from '@tanstack/react-query';
import {
  RorosGoalDraftService,
  type GoalDraftRequest,
  type GoalRefineRequest,
} from '@/services/roros/goal-draft.service';

export function useGoalDraft() {
  return useMutation({
    mutationFn: (request: GoalDraftRequest) => RorosGoalDraftService.draft(request),
  });
}

export function useGoalRefine() {
  return useMutation({
    mutationFn: (request: GoalRefineRequest) => RorosGoalDraftService.refine(request),
  });
}
